export type ActionOption = {
  text: string,
  value: string
}
export const cryptoSortItems: ActionOption[] = [
  {
    text: "全部",
    value: "",
  },
  {
    text: "区块链购币",
    value: "TronDeposit",
  },
  {
    text: "区块链卖币",
    value: "ChangeUsdt",
  },
  {
    text: "区块链转商家",
    value: "TronTransferBusiness",
  },
  {
    text: "保证金转入",
    value: "DepositTransferIn",
  },
  {
    text: "保证金转出",
    value: "DepositTransferOut",
  },
  {
    text: "商家转出钱包",
    value: "BusinessTransferVippayOut",
  },
];